import { useController, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { Add16, Subtract } from 'ui/icons';
import { PlacementType } from 'modules/placements/types';
import {
  CounterContainer,
  CounterLabel,
  CounterSelect,
  CounterWrapper,
  OperatorButton,
} from './styles';

const MAX_NUMBER_OF_CAMPAIGNS = 10;

const selectOptions = [...Array(MAX_NUMBER_OF_CAMPAIGNS).keys()]
  .map((i) => ({
    id: `option-${i + 1}`,
    label: i + 1,
    value: i + 1,
  }))
  .reverse()
  .filter((option) => option.value !== 1);

export const CampaignLimitCounter = () => {
  const { watch } = useFormContext();
  const {
    field: { onChange: setCampaignLimit, value: campaignLimit },
  } = useController({
    name: 'campaignLimit',
  });

  const placementType = watch('placementType');
  const isBannerType = placementType === PlacementType.Banner;

  useEffect(() => {
    if (campaignLimit < 1) setCampaignLimit(1);
    if (campaignLimit > 10) setCampaignLimit(10);
  }, [campaignLimit]);

  useEffect(() => {
    if (isBannerType) {
      setCampaignLimit(1);
    } else {
      setCampaignLimit(2);
    }
  }, [isBannerType]);

  return (
    <CounterContainer data-test="campaign-limit-counter">
      <CounterLabel>Up to</CounterLabel>
      <CounterWrapper>
        <OperatorButton
          data-test="counter-subtract"
          isDisabled={campaignLimit === 2 || isBannerType}
          onClick={() => setCampaignLimit(campaignLimit - 1)}
        >
          <Subtract />
        </OperatorButton>
        <CounterSelect
          id="campaign-limit"
          defaultValues={[campaignLimit]}
          onSelect={([selected]) => setCampaignLimit(selected as number)}
          options={selectOptions}
          isDisabled={isBannerType}
        />
        <OperatorButton
          data-test="counter-add"
          isDisabled={campaignLimit === 10 || isBannerType}
          onClick={() => setCampaignLimit(campaignLimit + 1)}
        >
          <Add16 />
        </OperatorButton>
      </CounterWrapper>
      <CounterLabel>campaigns at a time</CounterLabel>
    </CounterContainer>
  );
};
